export default "__VITE_ASSET__C3ymVEe2__"